module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows-c1c291c9aad883a9197afa96bbb3720e.png";